import React from 'react';
import { observable, action, toJS } from 'mobx';
import { Switch, Input } from 'antd';
import baseApi from '../../tool/base';
import util from '../../util/index';
const {
  catchApiError,
  getAccessToken,
} = util;

export class AppInfoStore {

  constructor(routing) {
    this.routing = routing;
  }
  @observable list = [];
  @observable current = 1;
  @observable pageSize = 10;
  @observable count = 0;
  @observable loading = false;
  @observable columns = [];

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  }
  
  @action
  init = () => {
    this.list = [];
    this.count = 0;
    this.current = 1;
    this.pageSize = 10;
    this.loading = false;
  }
  
  @action
  onChange = (domKey, value, record, needSave = true) => {
    const list = toJS(this.list);
    const res = [];
    list.forEach(v => {
      if (v.s_id === record.s_id) { 
        const node = { ...v };
        node[domKey] = value;
        res.push(node);
        if (needSave) this.edit({ s_id: record.s_id, s_ispreview: node.s_ispreview, s_pcurl: node.s_pcurl || '', s_mobiurl: node.s_mobiurl || '' });
      } else {
        res.push(v);
      }
    });
    this.list = res;
  }
  @action
  getColumns = () => {
    this.columns = [
      { dataIndex: 's_number', key: 's_number', title: '编号', width: '14%' },
      { dataIndex: 's_name', key: 's_name', title: '应用名称', width: '20%' },
      { dataIndex: 's_ispreview', key: 's_ispreview', title: '是否支持预览', width: '10%', render: (text, record) => <Switch checked={text === '1'} onChange={(value) => this.onChange('s_ispreview', value ? '1' : '0', record)}/>},
      {
        dataIndex: 's_pcurl', key: 's_pcurl', title: '预览地址(PC)', width: '28%', render: (text, record) => <Input value={text} disabled={record.s_ispreview !== '1'}
          onChange={(e) => this.onChange('s_pcurl', e.target.value, record, false)}
          onBlur={() => this.edit({ s_id: record.s_id, s_ispreview: record.s_ispreview, s_pcurl: record.s_pcurl || '', s_mobiurl: record.s_mobiurl || '' })} />
      },
      {
        dataIndex: 's_mobiurl', key: 's_mobiurl', title: '预览地址(MOBILE)', width: '28%', render: (text, record) => <Input value={text} disabled={record.s_ispreview !== '1'}
          onChange={(e) => this.onChange('s_mobiurl', e.target.value, record, false)}
          onBlur={() => this.edit({ s_id: record.s_id, s_ispreview: record.s_ispreview, s_pcurl: record.s_pcurl || '', s_mobiurl: record.s_mobiurl || '' })} />
      },
    ]
  }
  @action
  getList = (params = {}) => {
    this.loading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise((resolve) => {
      baseApi.callApi('/v4/soft/list', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        this.list = data.data;
        this.count = data.data.length;
        this.loading = false;
        resolve(data);
      });
    })
  }
  @action
  edit = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    }
    return new Promise((resolve) => {
      baseApi.callApi('/v4/soft/editpv', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        this.getList();
        resolve(data);
      });
    })
  }
}


// WEBPACK FOOTER //
// ./src/stores/price/AppInfoStore.js